import React from 'react';
import { connect } from 'react-redux';

import TravellerSelection from '../TravellerSelection/TravellerSelection';

import { setHotelAdult, setHotelChild } from '../../../store/actions/index';

const hotelRoom = (props) => { 
    return (
        <React.Fragment>
            <TravellerSelection 
                clicked={(event) => props.onSetAdult(event.target.value, props.room.id)} 
                active={props.adultActive}
                number={props.room.noOfAdults}
                type='adult'
                lob='hotel'
                roomindex={props.room.id}
                />
            <TravellerSelection 
                clicked={(event) => props.onSetChild(event.target.value, props.room.id)} 
                active={props.childActive}
                number={props.room.noOfChildren}
                type='child'
                lob='hotel'
                roomindex={props.room.id}
                childrenage={props.room.childrenAge}
                />
        </React.Fragment>
    );
}

const mapStateToProps = state => {
    return {
        adultActive: state.hotelTravellers.adultActive,
        childActive: state.hotelTravellers.childActive
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSetAdult: (value, id) => dispatch(setHotelAdult(value, id)),
        onSetChild: (value, id) => dispatch(setHotelChild(value, id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(hotelRoom);


// WEBPACK FOOTER //
// ./src/components/Travellers/HotelRoom/HotelRoom.js